import React, { FunctionComponent, ReactElement, ReactNode } from 'react';

import { css } from '@emotion/react';

import { palette } from '@styles/theme';

interface Props {
  children?: ReactNode | ReactElement;
}

const Form: FunctionComponent<Props> = ({ children }) => {
  return <ul css={container}>{children}</ul>;
};

export default Form;

const container = css`
  // overflow: hidden;
  padding: 0;
  margin: unset;
  margin-bottom: 10px;
  & > li {
    list-style: none;
  }
  & > li:nth-of-type(1) > ul {
    border-top: 2px solid ${palette.gray4};
  }

  width: 100%;

  display: flex;
  flex-direction: column;
`;
